module.exports = __webpack_public_path__ + "static/img/3.2c1b848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/TheMolding/3.jpg
// module id = rurJ
// module chunks = 1